import auditStatus from '@/constants/auditStatus'
import { COUNTRY_IBT } from '@/constants/internationalBankTransfer'
import { RegisterRoutePath } from '@/router/registerRoutes'
import store from '@/store'

// String
// return empty string if no need redirect
export const getIbtRedirectPath = async () => {
  // try catch to prevent store's states undefined
  try {
    if (!COUNTRY_IBT.includes(parseInt(store.state.common.countryCode))) {
      return '/home'
    } else {
      await Promise.all([
        store.dispatch('common/actionIbtPoiAuditStatus'),
        store.dispatch('common/actionIbtPoaAuditStatus'),
      ])
      if (
        store.state.common.ibtPoiAuditStatus === auditStatus.completed &&
        store.state.common.ibtPoaAuditStatus === auditStatus.completed
      ) {
        return ''
      } else {
        if (
          store.getters['common/isIbtPoiUnderReview'] ||
          store.getters['common/isIbtPoaUnderReview'] ||
          store.getters['common/isIbtPoiResubmit'] ||
          store.getters['common/isIbtPoaResubmit']
        ) {
          return RegisterRoutePath.ibtVerification
        } else {
          return RegisterRoutePath.ibtRegister
        }
      }
    }
  } catch (error) {
    return ''
  }
}

// String
// return empty string if no need redirect
export const getIbtRegisterRedirectPath = async () => {
  // try catch to prevent store's states undefined
  try {
    if (!COUNTRY_IBT.includes(parseInt(store.state.common.countryCode))) {
      return '/home'
    } else {
      await Promise.all([
        store.dispatch('common/actionIbtPoiAuditStatus'),
        store.dispatch('common/actionIbtPoaAuditStatus'),
      ])

      if (
        store.state.common.ibtPoiAuditStatus === auditStatus.completed &&
        store.state.common.ibtPoaAuditStatus === auditStatus.completed
      ) {
        return '/rebateWithdraw'
      } else {
        return ''
      }
    }
  } catch (error) {
    return ''
  }
}
